import * as React from "react";
import {
    useHistory,
    useLocation,
    useParams,
    useRouteMatch,
} from "react-router";

export const useRouter = <T extends object = any>() => {
    const history = useHistory<any>();
    const location = useLocation<any>();
    const match = useRouteMatch<T>();

    const params = useParams<T>();

    return {
        history,
        location,
        match,
        /**
         * provides access to query parameters.  always as type of string.
         */
        params,
    };
};
